/* ========================================================================
   HERMES ESTUFA v1 — Expedición Nocturna · Basecamp
   Anim set: preloader altímetro 0→2600 MSNM · BlurText · letter reveal ·
             flashlight (linterna) reveal · topo lines draw · count-up ·
             fade-rise stagger · variant sync · anti-spy · desktop-block ·
             Releasit integration · sticky CTA
   ======================================================================== */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var section = $('.hm-est');
  if (!section) return;

  var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  if (isTouch) document.body.classList.add('is-touch');

  /* ── 0) DESKTOP BLOCK + ANTI-SPY ─────────────────────────────── */
  var caught = $('.hm-est-caught');

  function isDesktop() {
    return (
      window.matchMedia('(min-width: 1024px)').matches ||
      (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !isTouch)
    );
  }
  function showCaught(mode) {
    if (!caught) return;
    caught.classList.remove('is-mode-spy', 'is-mode-desktop');
    caught.classList.add('is-active', 'is-mode-' + mode);
  }

  if (section.classList.contains('hm-est--desktop-block') && isDesktop()) {
    showCaught('desktop');
    return; // short-circuit — no further init on blocked desktop
  }

  if (section.classList.contains('hm-est--anti-spy')) {
    document.addEventListener('contextmenu', function (e) { e.preventDefault(); showCaught('spy'); });
    document.addEventListener('keydown', function (e) {
      var key = (e.key || '').toLowerCase();
      if (key === 'f12') { e.preventDefault(); showCaught('spy'); return; }
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (key === 'i' || key === 'j' || key === 'c')) { e.preventDefault(); showCaught('spy'); return; }
      if ((e.ctrlKey || e.metaKey) && (key === 'u' || key === 's' || key === 'p')) { e.preventDefault(); showCaught('spy'); return; }
    });
    setInterval(function () {
      var delta = Math.abs(window.outerWidth - window.innerWidth) + Math.abs(window.outerHeight - window.innerHeight);
      if (delta > 200) showCaught('spy');
    }, 1500);
    $$('.hm-est img, .hm-est video').forEach(function (el) {
      el.setAttribute('draggable', 'false');
      el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ── 1) PRELOADER altímetro 0 → 2600 MSNM + rotating words ───── */
  (function preloader() {
    var pre = $('#hm-est-preloader'), ctr = $('#hm-est-counter'), bar = $('#hm-est-bar'), wrap = $('#hm-est-words');
    if (!pre || !ctr || !bar) return;
    var target = 2600, duration = 2200, start = performance.now();
    function fmt(n) { return n.toLocaleString('es-CO'); }
    function tick(t) {
      var p = Math.min(1, (t - start) / duration);
      var ease = 1 - Math.pow(1 - p, 3);
      ctr.textContent = fmt(Math.floor(ease * target));
      bar.style.width = (ease * 100) + '%';
      if (p < 1) requestAnimationFrame(tick);
      else setTimeout(function () { pre.classList.add('is-done'); }, 340);
    }
    requestAnimationFrame(tick);
    if (wrap) {
      var pwords = $$('.hm-est-pw', wrap), idx = 0;
      setInterval(function () {
        pwords[idx].classList.remove('active');
        idx = (idx + 1) % pwords.length;
        pwords[idx].classList.add('active');
      }, 480);
    }
  })();

  /* ── 2) BLUR-TEXT word-by-word (hero headline) ───────────────── */
  (function blurText() {
    $$('.hm-est-blur-text').forEach(function (el) {
      var src = el.getAttribute('data-blur-text') || '';
      el.textContent = '';
      src.split(/\s+/).filter(Boolean).forEach(function (w, i) {
        var span = document.createElement('span');
        span.className = 'hm-est-blur-text__word';
        span.style.setProperty('--d', (0.15 + i * 0.10) + 's');
        span.textContent = w;
        el.appendChild(span);
      });
    });
    setTimeout(function () { $$('.hm-est-blur-text__word').forEach(function (w) { w.classList.add('is-in'); }); }, 820);
  })();

  /* ── 3) LETTER-BY-LETTER reveal (pull-quote) ─────────────────── */
  (function letterReveal() {
    $$('[data-letter-reveal]').forEach(function (el) {
      var src = el.getAttribute('data-source') || '';
      el.innerHTML = '';
      var rx = /(<em>[^<]*<\/em>)|(\S)|(\s+)/g, m, i = 0;
      while ((m = rx.exec(src)) !== null) {
        if (m[1]) {
          var emTxt = m[1].replace(/<\/?em>/g, ''), em = document.createElement('em');
          for (var k = 0; k < emTxt.length; k++) {
            var ch = emTxt[k];
            if (ch === ' ') { em.appendChild(document.createTextNode(' ')); continue; }
            var s = document.createElement('span');
            s.className = 'hm-est-letter'; s.style.setProperty('--d', (i * 0.018) + 's'); s.textContent = ch;
            em.appendChild(s); i++;
          }
          el.appendChild(em);
        } else if (m[2]) {
          var sp = document.createElement('span');
          sp.className = 'hm-est-letter'; sp.style.setProperty('--d', (i * 0.018) + 's'); sp.textContent = m[2];
          el.appendChild(sp); i++;
        } else if (m[3]) { el.appendChild(document.createTextNode(m[3])); }
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { $$('.hm-est-letter', el).forEach(function (l) { l.classList.add('is-in'); }); io.disconnect(); }
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  })();

  /* ── 4) LINTERNA — flashlight reveal (Nike spotlight adaptado) ── */
  (function linterna() {
    var stage = $('[data-hm-est-linterna]');
    if (!stage) return;
    var idle = true, idleT = 0, raf;
    function setPos(xPct, yPct) {
      stage.style.setProperty('--lx', xPct + '%');
      stage.style.setProperty('--ly', yPct + '%');
    }
    setPos(50, 55);
    /* idle: la linterna pasea sola hasta que el usuario toca */
    function idleLoop(t) {
      if (!idle) return;
      idleT = t / 1000;
      var x = 50 + Math.sin(idleT * 0.5) * 26;
      var y = 55 + Math.cos(idleT * 0.34) * 14;
      setPos(x, y);
      raf = requestAnimationFrame(idleLoop);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { stage.classList.add('is-on'); raf = requestAnimationFrame(idleLoop); }
        else { cancelAnimationFrame(raf); }
      });
    }, { threshold: 0.3 });
    io.observe(stage);

    function fromEvent(clientX, clientY) {
      idle = false;
      var r = stage.getBoundingClientRect();
      var x = ((clientX - r.left) / r.width) * 100;
      var y = ((clientY - r.top) / r.height) * 100;
      setPos(Math.max(0, Math.min(100, x)), Math.max(0, Math.min(100, y)));
    }
    stage.addEventListener('mousemove', function (e) { fromEvent(e.clientX, e.clientY); });
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; if (t) fromEvent(t.clientX, t.clientY); }, { passive: true });
    stage.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (t) fromEvent(t.clientX, t.clientY); }, { passive: true });
    stage.addEventListener('mouseleave', function () { idle = true; requestAnimationFrame(idleLoop); });
  })();

  /* ── 5) TOPO LINES draw on view ──────────────────────────────── */
  (function topoLines() {
    $$('.hm-est-topo').forEach(function (wrap) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { wrap.classList.add('is-in'); io.disconnect(); }
        });
      }, { threshold: 0.2 });
      io.observe(wrap);
    });
  })();

  /* ── 6) COUNT-UP stats ───────────────────────────────────────── */
  (function countUp() {
    $$('.hm-est-stat__num').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-target') || '0');
      var suffix = el.getAttribute('data-suffix') || '';
      var prefix = el.getAttribute('data-prefix') || '';
      if (isNaN(target) || target <= 0) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var dur = 1500, start = performance.now();
          function tick(t) {
            var p = Math.min(1, (t - start) / dur), ease = 1 - Math.pow(1 - p, 3);
            el.textContent = prefix + Math.floor(ease * target) + suffix;
            if (p < 1) requestAnimationFrame(tick); else el.textContent = prefix + target + suffix;
          }
          requestAnimationFrame(tick);
          entry.target.classList.add('is-in');
          io.disconnect();
        });
      }, { threshold: 0.5 });
      io.observe(el);
    });
  })();

  /* ── 7) FADE-RISE stagger ────────────────────────────────────── */
  (function fadeRise() {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.16 });
    $$('.hm-est-stat, .hm-est-step, .hm-est-bento__cell, .hm-est-parallax__block').forEach(function (el, i) {
      el.style.setProperty('--sd', (i % 4 * 0.08) + 's');
      io.observe(el);
    });
  })();

  /* ── 8) VARIANT SELECTOR sync (no-op si SIMPLE) ──────────────── */
  (function variantSync() {
    var wrap = $('[data-hm-est-variants]');
    if (!wrap) return;
    var jsonEl = $('[data-hm-est-variants-json]', wrap), variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) {}
    var groups = $$('.hm-est-hero__variant-options', wrap);
    var selected = new Array(groups.length);
    groups.forEach(function (grp, i) {
      var act = $('.hm-est-variant-opt--active', grp);
      selected[i] = act ? act.getAttribute('data-option-value') : null;
    });
    function formatCOP(cents) { return '$' + (cents / 100).toLocaleString('es-CO', { maximumFractionDigits: 0 }); }
    function findVariant() {
      return variants.find(function (v) {
        var o = [v.option1, v.option2, v.option3];
        for (var i = 0; i < groups.length; i++) { if (selected[i] && o[i] !== selected[i]) return false; }
        return true;
      });
    }
    function apply(v) {
      if (!v) return;
      var inp = $('[data-hm-est-variant-input]'); if (inp) inp.value = v.id;
      if (typeof v.price === 'number') {
        var p = formatCOP(v.price);
        [$('.hm-est-hero__price-now'), $('.hm-est-final__now'), $('.hm-est-sticky-cta__now')].forEach(function (e) { if (e) e.textContent = p; });
      }
      window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS = [{ id: v.id, quantity: 1 }];
    }
    groups.forEach(function (grp, gi) {
      $$('.hm-est-variant-opt', grp).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $$('.hm-est-variant-opt', grp).forEach(function (b) { b.classList.remove('hm-est-variant-opt--active'); });
          btn.classList.add('hm-est-variant-opt--active');
          selected[gi] = btn.getAttribute('data-option-value');
          apply(findVariant());
        });
      });
    });
  })();

  /* ── 9) RELEASIT INTEGRATION ─────────────────────────────────── */
  (function releasit() {
    var heroCta = $('[data-hm-est-cta-proxy]');
    var mainCta = $('[data-hm-est-main-cta]');
    if (heroCta) {
      heroCta.addEventListener('click', function (e) {
        var rsiBtn = document.querySelector('._rsi-buy-now-button:not(._rsi-buy-now-button-floating), #_rsi-buy-now-button-overwrite');
        if (rsiBtn) { e.preventDefault(); rsiBtn.click(); return; }
        if (mainCta) { e.preventDefault(); mainCta.click(); }
      });
    }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var rsiBtn = document.querySelector('._rsi-buy-now-button, #_rsi-buy-now-button-overwrite');
      if (rsiBtn) { clearInterval(poll); console.info('[HERMES estufa-v1] Releasit button detected.'); }
      else if (attempts > 40) { clearInterval(poll); console.warn('[HERMES estufa-v1] Releasit not detected — check Dropi metafield + dashboard.'); }
    }, 500);
  })();

  /* ── 10) Scroll-hint hide ────────────────────────────────────── */
  (function scrollHint() {
    var hint = $('.hm-est-hero__scrollhint'); if (!hint) return;
    var hide = function () { if (window.scrollY > 80) { hint.style.opacity = '0'; window.removeEventListener('scroll', hide); } };
    window.addEventListener('scroll', hide, { passive: true });
  })();

  /* ── 10.5) RELEASIT SUBMIT SKIN (fix v1c) ────────────────────── */
  /* Releasit pinta el submit del modal con INLINE STYLES + !important
     (background negro). CSS no puede ganarle — lo sobrescribimos vía JS
     re-seteando el inline style con priority 'important'. */
  (function releasitSubmitSkin() {
    function skin(el) {
      if (!el || el.getAttribute('data-hm-est-skinned') === '1') return;
      el.style.setProperty('background', 'linear-gradient(135deg, #D97E2E, #E8973B)', 'important');
      el.style.setProperty('background-color', '#E8973B', 'important');
      el.style.setProperty('color', '#000000', 'important');
      el.style.setProperty('border', '2px solid #F2B469', 'important');
      el.style.setProperty('border-radius', '999px', 'important');
      el.style.setProperty('box-shadow', '0 0 28px rgba(232,151,59,0.45), 0 6px 18px rgba(0,0,0,0.25)', 'important');
      el.style.setProperty('font-weight', '700', 'important');
      el.style.setProperty('text-transform', 'uppercase', 'important');
      el.style.setProperty('letter-spacing', '0.04em', 'important');
      el.style.setProperty('min-height', '54px', 'important');
      el.setAttribute('data-hm-est-skinned', '1');
      /* texto interno negro legible */
      $$('*', el).forEach(function (n) {
        if (n.tagName === 'IMG' || n.tagName === 'SVG') return;
        n.style.setProperty('color', '#000000', 'important');
      });
    }
    function sweep() {
      $$('._rsi-modal-submit-button, [class*="_rsi"][class*="submit-button"]:not([class*="build-block"]), [class*="_rsi-build-block-submit"] button').forEach(skin);
    }
    sweep();
    var mo = new MutationObserver(function () { sweep(); });
    mo.observe(document.body, { childList: true, subtree: true });
    /* re-sweep por si Releasit re-aplica su inline al abrir el modal */
    var rp = setInterval(sweep, 800);
    setTimeout(function () { clearInterval(rp); }, 40000);
    document.addEventListener('click', function () { setTimeout(sweep, 300); setTimeout(sweep, 900); }, true);
  })();

  /* ── 11) STICKY CTA bottom (mobile) ──────────────────────────── */
  (function stickyCta() {
    var sticky = $('.hm-est-sticky-cta'), heroCta = $('.hm-est-hero__cta'), finalSec = $('#hm-est-cta-final');
    if (!sticky || !heroCta) return;
    function killFloating() {
      $$('[class*="_rsi-buy-now"][class*="floating"], ._rsi-buy-now-button-floating, [class*="_rsi-floating"]').forEach(function (el) {
        el.style.display = 'none'; el.style.visibility = 'hidden'; el.style.opacity = '0'; el.style.pointerEvents = 'none';
      });
    }
    killFloating();
    var kp = setInterval(killFloating, 500); setTimeout(function () { clearInterval(kp); }, 24000);

    var ioHero = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { sticky.classList.toggle('is-visible', !entry.isIntersecting); });
    }, { threshold: 0.1 });
    ioHero.observe(heroCta);

    if (finalSec) {
      var ioFinal = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { section.classList.toggle('is-final-cta-visible', entry.isIntersecting); });
      }, { threshold: 0.15, rootMargin: '0px 0px -40% 0px' });
      ioFinal.observe(finalSec);
    }

    var btn = $('.hm-est-sticky-cta__btn', sticky);
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var rsiBtn = document.querySelector('._rsi-buy-now-button:not(._rsi-buy-now-button-floating), #_rsi-buy-now-button-overwrite');
        if (rsiBtn) { rsiBtn.click(); return; }
        var mainCta = document.querySelector('[data-hm-est-main-cta]');
        if (mainCta) { mainCta.click(); return; }
        finalSec && finalSec.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  })();

  console.info('[HERMES estufa-v1] Section initialized.');
})();
